export const INLINE_EDD_TEST_ID = 'InlineEdd';
export const INLINE_EDD_SEARCH_INPUT_TEST_ID = 'InlineEddSearchInput';
export const INLINE_EDD_SEARCHED_EDD_TEST_ID = 'InlineEddSearchedEdd';
export const INLINE_EDD_CANCEL_BUTTON_TEST_ID = 'InlineEddCancelButton';
export const INLINE_EDD_CALCULATE_BUTTON_TEST_ID = 'InlineEddCalculateButton';
export const INLINE_EDD_CLOSE_BUTTON_TEST_ID = 'InlineEddCloseButton';
export const INLINE_EDD_EDIT_TEST_ID = 'InlineEddEdit';
export const INLINE_EDD_ERROR_MODAL_CONTENT_TEST_ID = 'InlineEddErrorModalContent';
export const INLINE_EDD_INPUT_ERROR_TEST_ID = 'InlineEddInputError';
